import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex);

const store = new Vuex.Store({
  // 设置全局状态
 state : {
    isAdmin: false,     // 是否管理员
    companyId: "",      // 公司ID
    topicData: {},      // 传给分类统计的专题数据
 },


});
export default store


// WEBPACK FOOTER //
// ./src/store/index.js